export default "__VITE_ASSET__C9MM1ddz__"